import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Firmalar() {
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ ad: '', aciklama: '' });
  const [duzenle, setDuzenle] = useState(null);

  useEffect(() => { fetchFirmalar(); }, []);

  async function fetchFirmalar() {
    const { data } = await supabase.from('firmalar').select('*').order('ad');
    setFirmalar(data || []);
    setLoading(false);
  }

  function yeniAc() { setForm({ ad: '', aciklama: '' }); setDuzenle(null); setModal(true); }
  function duzenleAc(f) { setForm({ ad: f.ad, aciklama: f.aciklama || '' }); setDuzenle(f.id); setModal(true); }

  async function handleKaydet() {
    if (!form.ad) return;
    if (duzenle) {
      await supabase.from('firmalar').update({ ad: form.ad, aciklama: form.aciklama }).eq('id', duzenle);
    } else {
      await supabase.from('firmalar').insert({ ad: form.ad, aciklama: form.aciklama });
    }
    setModal(false);
    fetchFirmalar();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu firmayı silmek istediğinizden emin misiniz?')) return;
    await supabase.from('firmalar').delete().eq('id', id);
    fetchFirmalar();
  }

  async function toggleAktif(f) {
    await supabase.from('firmalar').update({ aktif: !f.aktif }).eq('id', f.id);
    fetchFirmalar();
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Firmalar</h1>
          <p className="page-subtitle">{firmalar.length} firma kayıtlı</p>
        </div>
        <button className="btn btn-primary" onClick={yeniAc}>+ Yeni Firma</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th>Firma Adı</th><th>Açıklama</th><th>Durum</th><th>İşlem</th></tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="loading">Yükleniyor...</td></tr>
            ) : firmalar.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Henüz firma eklenmemiş. + Yeni Firma butonuna basın.</td></tr>
            ) : firmalar.map(f => (
              <tr key={f.id}>
                <td style={{ fontWeight: 600 }}>{f.ad}</td>
                <td style={{ color: 'var(--text2)' }}>{f.aciklama || '-'}</td>
                <td>
                  <span onClick={() => toggleAktif(f)} className={`badge ${f.aktif ? 'badge-green' : 'badge-red'}`} style={{ cursor: 'pointer' }}>
                    {f.aktif ? '✓ Aktif' : '✗ Pasif'}
                  </span>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => duzenleAc(f)}>Düzenle</button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleSil(f.id)}>Sil</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{duzenle ? 'Firma Düzenle' : 'Yeni Firma'}</h3>
            <div className="form-group">
              <label className="label">Firma Adı *</label>
              <input className="input" value={form.ad} onChange={e => setForm(f => ({ ...f, ad: e.target.value }))} placeholder="FIPGL23, Vitanimal, Broiler..." autoFocus />
            </div>
            <div className="form-group">
              <label className="label">Açıklama</label>
              <textarea className="textarea" value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))} placeholder="Firma hakkında kısa bilgi..." />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={!form.ad}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
